import { createRouter, createWebHistory } from 'vue-router';
import WordPreview from './views/Image.vue';
import ChoosePerson from "./views/Folder.vue";
import BidDocument from "@/views/Camera.vue";
import VideoPreview from "@/views/Video.vue";
import ResultsView from "@/views/Results.vue";
import ExamplesView from "@/views/Examples.vue";

// Vue CLI 只用 process.env.NODE_ENV
const base = process.env.NODE_ENV === 'production' ? '/swine-sddnet/' : '/'

const routes = [
  {
    path: '/',
    redirect: 'image',
    children: [
      { path: 'image', component: WordPreview },
      { path: 'folder', component: ChoosePerson },
      { path: 'camera', component: BidDocument },
      { path: 'video', component: VideoPreview },
      { path: 'results', component: ResultsView },
      { path: 'examples', component: ExamplesView },
    ]
  }
]

const router = createRouter({
    history: createWebHistory(base),
    routes,
});

export default router;